import React, { Component } from 'react';
import Content from '../sections/ResetPassword/Content';

class ResetPassword extends Component {
    render() {
        return (
            <div className="ms-body ms-primary-theme ms-logged-out">

                <main className="body-content">
                    <Content data={this.props}/>
                </main>
            </div>
        );
    }
}

export default ResetPassword;
